document.addEventListener('DOMContentLoaded', () => {
  const isDesktop = window.matchMedia('(min-width: 990px)');

  const closeAllMenus = (exceptMenu = null) => {
    document.querySelectorAll('header-menu details.mega-menu[open]').forEach((menu) => {
      if (menu !== exceptMenu) menu.removeAttribute('open');
    });
  };

  document.querySelectorAll('header-menu details.mega-menu').forEach((menu) => {
    let closeTimer;

    const triggers = menu.querySelectorAll('[data-mega-trigger]');
    const cards = menu.querySelectorAll('[data-mega-image]');

    const hideAllCards = () => {
      cards.forEach((card) => {
        card.style.display = 'none';
      });
    };

    const showCard = (key) => {
      if (!key || key === 'view-all') {
        hideAllCards();
        return;
      }

      cards.forEach((card) => {
        card.style.display = card.getAttribute('data-mega-image') === key ? 'block' : 'none';
      });
    };

    if (cards.length > 0) {
      cards.forEach((card, index) => {
        card.style.display = index === 0 ? 'block' : 'none';
      });
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => {
        if (!isDesktop.matches) return;

        const label = trigger.textContent.trim().toLowerCase();
        const key = trigger.getAttribute('data-mega-trigger');

        if (label === 'view all') {
          hideAllCards();
          return;
        }

        showCard(key);
      });
    });

    menu.addEventListener('mouseenter', () => {
      if (!isDesktop.matches) return;

      clearTimeout(closeTimer);
      closeAllMenus(menu);
      menu.setAttribute('open', '');

      if (cards.length > 0) {
        cards.forEach((card, index) => {
          card.style.display = index === 0 ? 'block' : 'none';
        });
      }
    });

    menu.addEventListener('mouseleave', () => {
      if (!isDesktop.matches) return;

      closeTimer = setTimeout(() => {
        menu.removeAttribute('open');
      }, 220);
    });

    menu.querySelector('summary')?.addEventListener('click', (event) => {
      if (!isDesktop.matches) return;

      event.preventDefault();

      if (menu.hasAttribute('open')) {
        menu.removeAttribute('open');
      } else {
        closeAllMenus(menu);
        menu.setAttribute('open', '');
      }
    });
  });
});